import { useInfiniteQueryUserLibraryPrograms } from '@ifit/gateway-wolf-athenaeum-service';
import getNextPageParam from '../../get-next-page';
import { useInfiniteQueryOptions, challengeStoreFF } from '../../query-options';
import { useFeatureFlags } from '../../../../helpers/good-cop-helper';
import { PAGE_SIZE } from '../../../library';

export const useListProgramsInfiniteQuery = (trainerId: string) => {
  const featureFlags = useFeatureFlags([challengeStoreFF]);
  const enabled = featureFlags[challengeStoreFF]
    ? (featureFlags[challengeStoreFF] as boolean)
    : false;
  const requiredOpts = useInfiniteQueryOptions();
  const opts = {
    ...requiredOpts,
    trainerId: trainerId,
    perPage: PAGE_SIZE,
    ...(enabled && { challengeEndTimestampSet: false }),
  };
  return useInfiniteQueryUserLibraryPrograms(opts, { getNextPageParam });
};
